define('app/views/travel_search_train_view',['app/setup',
  'jquery.sumoselect',
  'parsley',
  'app/lib/pwt/persian-date',
  'app/lib/pwt/persian-datepicker',
  'app/collections/travel_train_collection'],
  function(takhfifan, sumoSelect, parsley, persianDate, pdp) {
  takhfifan.TravelSearchTrainView = Backbone.View.extend({
    events: {
      'submit form.travel-search': 'searchFormSubmit',
      'change select': 'setModelData',
      'click .tkh-travel-train-search__dir': 'changeDirection',
      'click .passenger-type label input': 'showHideAge',
      'click .coupe-type label input': 'showHideType',
      'click .tkh-payment-item': 'selectPaymentMethod'
    },

    cardTemplate: ( $('#travel-train-card').length > 0 ) ?
      _.template( $('#travel-train-card').html() ) : '',

    trainCartTemplate: ( $('#travel-train-online-checkout-cart').length > 0 ) ?
      _.template( $('#travel-train-online-checkout-cart').html() ) : '',

    initialize: function () {
      window.persianDate = persianDate;
      Backbone.Validation.bind(this);

      this.routes = JSON.parse(this.$('.tkh-travel-train-search__routes').val());
      $('.tkh-travel-train-date-picker[data-type=to]').hide();

      this.generateSelectBoxes();
      this.generateDatePickers();
      this.generateAddToCartFrom();
      this.collection = new takhfifan.TravelTrainCollection;

      this.isRajaEnabled = $('.tkh-travel-train-search__rajaIsEnabled').val() === 'true';
      if(this.isRajaEnabled) {
        this.getStations();
      }

      this.initFiltersAndDealCardsEvents();
      this.filters = {};
      this.sort = "date";
      this.travelType = "going";
      this.currentTravelType = "going";
      this.pageSize = 20;
      this.callData = [];
      this.tickets = [];
      this.isFirstPaymentCalled = false;
      this.optionalServicesPrices = [];
      this.totalOptionalServicesPrice = 0;
      this.passengersPricesObj = {};
    },

    getStations: function () {
      takhfifan.eventHub.trigger('travel:disable');
      var _this = this;
      this.collection.fetchStations({
        dataType: 'json',
        data: {
          form_key: takhfifan.formKey
        },
        success: function (collection) {
          var citiesCode=["1","191","55","25","37","219","259","255"].reverse();
           collection.stationsModel.sort(function(firstCity, secondCity){
              var firstIdx = citiesCode.findIndex(function checkCode(myCode) {
                return myCode === firstCity.code;
              });
              var secondIdx = citiesCode.findIndex(function checkCode(myCode) {
                return myCode === secondCity.code;
              })
              if(firstIdx > secondIdx) return -1
              if(firstIdx < secondIdx) return 1
              return 0
            })

          $.each(collection.stationsModel, function (i, item) {
            $('select.tkh-travel-train-search__txt[name=origin]')[0].sumo.add(item.code, item.name);
            $('select.tkh-travel-train-search__txt[name=destination]')[0].sumo.add(item.code, item.name);
          });
          takhfifan.eventHub.trigger('travel:enable');
        },
        error: function () {},
        complete: function () {}
      })
    },

    generateSelectBoxes: function(){
      this.$('select.tkh-travel-train-search__txt').SumoSelect({
        search: true,
        showTitle: true,
        noMatch: 'موردی یافت نشد.',
        searchText: 'جستجو کنید...'
      });
      this.$('select.tkh-travel-plane-search__number').SumoSelect();
    },

    changeDirection: function(e){
      var $target = $(e.target),
          is2Way = parseInt($target.data('dir'),10) === 2;

      if($target.hasClass('active')){
        return;
      }
      $('.tkh-travel-train-date-picker').css('display', 'block');
      if(!is2Way){
        $('.tkh-travel-train-date-picker[data-type="to"]').css('display', 'none');
      }

      this.model.set({is2Way: is2Way});
      this.resetDatePickers();
      this.$('.tkh-travel-train-search__dir').toggleClass('active');
      this.validateForm();
    },

    setModelData: function(e){
      var $this = $(e.target),
          name = $this.prop('name'),
          attrs={};

      if(!this.isRajaEnabled) {
        if (name === "origin") {
          this.$('.tkh-travel-train-search__txt[name ="destination"]').val('none');
          this.$('.tkh-travel-train-search__txt[name ="destination"] option').attr('disabled', 'disabled');
          this.$('.tkh-travel-train-search__txt[name ="destination"] option[data-from~="' + $this.val() + '"]').removeAttr('disabled');
          this.$('.tkh-travel-train-search__txt[name ="destination"]')[0].sumo.reload();
          this.resetDatePickers();
          attrs['destination'] = null;
        } else if (name === "destination") {
          this.resetDatePickers();
        }
      }

      var selectedOptionText = '';
      if(name === 'origin') {
        selectedOptionText = this.$(".tkh-travel-train-search__txt.origin option:selected").text();
      }
      else if (name === 'destination'){
        selectedOptionText = this.$(".tkh-travel-train-search__txt.destination option:selected").text();
      }

      attrs[name] = $this.val();
      if(selectedOptionText !== '') {
        attrs[name + '_name'] = selectedOptionText;
      }
      this.model.set(attrs);

      this.validateForm();
    },

    resetDatePickers: function () {
      this.$('.tkh-travel-train-date-picker');
      this.$('.tkh-travel-train-date-picker').each(function(){
        var $this = $(this);
        //$this.addClass('travel-search-types__form__dp--disabled');
        $this.removeClass('travel-search-types__form__dp--has-value');
        $this.html($(this).data("ph"))
      });
      this.model.unset('departDate');
      this.model.unset('returnDate');
    },

    validateForm: function () {
      if(this.model.get('origin') && this.model.get('destination') && !this.model.get('departDate') && !this.model.get('returnDate')){
        if(!this.isRajaEnabled) {
          this.sendAjaxRequest();
        }
      }
      this.model.validate();
      if(this.model.isValid() && this.model.get('adult') && this.model.get('adult') > 0){
        this.$('.travel-search__btn').removeAttr('disabled');
      }else{
        this.$('.travel-search__btn').attr('disabled','disabled');
      }
    },

    searchFormSubmit: function (e){
      e.preventDefault();
      takhfifan.eventHub.trigger('travel:disable');
      if(this.isRajaEnabled){
        var el = $('.passenger-entry');
        if(el.css('display') === 'block'){
          el.hide();
        }
        this.searchTrains();
      } else{
        this.renderSearchResults();
      }
    },

    sendAjaxRequest: function () {
      var _this = this,
        fromId = this.model.get('origin'),
        toId = this.model.get('destination'),
        fromName = this.model.get('origin_name'),
        toName = this.model.get('destination_name'),
        departureRoutes=null;

      if(this.isRajaEnabled){
        departureRoutes = _.where(this.routes, {fromName: fromName, toName: toName})
      }
      else{
        departureRoutes = _.where(this.routes, {fromId: fromId, toId: toId})
      }
      var returnRoutes = this.model.get('is2Way') ? _.where(this.routes, {fromId: toId, toId: fromId}) : [],
        departureIds = _.pluck(departureRoutes, "pid"),
        returnIds = _.pluck(returnRoutes, "pid");

      takhfifan.eventHub.trigger('travel:disable');
      $('.travel-train-results').addClass('travel-train-results--no-result');
      this.collection.fetch({
        dataType: 'json',
        traditional: false,
        data: {
          form_key: takhfifan.formKey,
          pids: departureIds,
          rpids: returnIds,
          capacity: this.model.get('passengers')
        },
        success: function (collection, response, options) {
          if(_this.isRajaEnabled) {
            _this.renderSearchResults(collection);
          }else{
            _this.generateDatePickersWithoutRaja(collection);
          }
        },
        error: function() {},
        complete: function () {}
      })
    },

    searchTrains: function(){
      var _this = this,
          origin = parseInt(this.model.get('origin')),
          destination = parseInt(this.model.get('destination')),
          date = this.model.get('departDate'),
          ticket_type = this.model.get('ticket_type'),
          is2Way = this.model.get('is2Way'),
          returnDate = null;

      takhfifan.eventHub.trigger('travel:disable');
      $('.travel-train-results').addClass('travel-train-results--no-result');

      if(is2Way){
        returnDate = this.model.get('returnDate');
        this.collection.search({
          dataType: 'json',
          data: {
            form_key: takhfifan.formKey,
            origin: origin,
            destination: destination,
            date:date,
            ticket_type:ticket_type,
            is2Way: is2Way,
            travel_type: 'going'
          },
          success: function (collection, response, options) {
            _this.collection.search({
              dataType: 'json',
              data: {
                form_key: takhfifan.formKey,
                origin: destination,
                destination: origin,
                date:returnDate,
                ticket_type:ticket_type,
                is2Way: is2Way,
                travel_type: 'return'
              },
              success: function (collection, response, options) {
                _this.sendAjaxRequest();
              },
              error: function() {},
              complete: function () {}
            })
          },
          error: function() {},
          complete: function () {}
        })
      } else {
        this.collection.search({
          dataType: 'json',
          data: {
            form_key: takhfifan.formKey,
            origin: origin,
            destination: destination,
            date:date,
            ticket_type:ticket_type,
            is2Way: is2Way,
            travel_type: 'going'
          },
          success: function (collection, response, options) {
            _this.sendAjaxRequest();
          },
          error: function() {},
          complete: function () {}
        })
      }
    },

    formatDate: function(unix){
      var currentDate = new Date(unix);
      return (currentDate.getFullYear()+"-"+this.addLeadingZero(currentDate.getMonth() +1) +"-"+this.addLeadingZero(currentDate.getDate()));
    },

    addLeadingZero: function (n) {
      var s = "0"+n;
      return s.substr(s.length-2);
    },

    generateDatePickers: function(){
      var _this = this,
        dpOptions = {
          onSelect: function(unix){
            var selectedDate=this.model.state.selected,
              $placeHolder = $(this.model.inputElement),
              selectedDateText = _this.formatDate(unix);
            $placeHolder.html(selectedDate.year+"/"+selectedDate.month+"/"+selectedDate.date);
            $placeHolder.addClass('travel-search-types__form__dp--has-value');

            if($placeHolder.data("type")==="from"){
              _this.model.set({departDate:selectedDateText});
              _this.validateForm();

              _this.fromDP.touched = true;
              if (_this.toDP && _this.toDP.options && _this.toDP.options.minDate != unix) {
                var cachedValue = _this.toDP.getState().selected.unixDate;
                _this.toDP.options = {minDate: unix};
                if (_this.toDP.touched) {
                  _this.toDP.setDate(cachedValue);
                }
              }

            }else{
              _this.model.set({returnDate:selectedDateText});
              _this.validateForm();

              _this.toDP.touched = true;
              if(_this.fromDP && _this.fromDP.options && _this.fromDP.options.maxDate != unix){
                var cachedValue = _this.fromDP.getState().selected.unixDate;
                _this.fromDP.options = {maxDate: unix};
                if (_this.fromDP.touched) {
                  _this.fromDP.setDate(cachedValue);
                }
              }
            }
          },
          minDate: new Date(),
          maxDate: null,
          autoClose: true,
          toolbox:{
            calendarSwitch:{
              enabled: false
            }
          }
        };

      var $datePickers = $(".tkh-travel-train-date-picker");
      $datePickers.each(function(){
        $(this).removeClass('travel-search-types__form__dp--has-value');
        $(this).html($(this).data("ph"));
      });

      if(this.fromDP){
        this.fromDP.options = dpOptions;
      }
      if(this.toDP){
        this.toDP.options = dpOptions;
      }
      if(!this.toDP || !this.fromDP){
        $datePickers.each(function(){
          var dp = $(this).pDatepicker(dpOptions);
          if($(this).data("type")==="from"){
            _this.fromDP = dp;
          }else{
            _this.toDP = dp;
          }
        });
      }
    },

    generateDatePickersWithoutRaja: function(){
      var
        models = this.collection.toJSON(),
        departureDates = _.uniq(_.pluck(models, "departureDate")),
        returnDates = _.uniq(_.pluck(models, "returnDate")),
        _this = this,
        dpOptions = {
          onSelect: function(unix){
            var selectedDate=this.model.state.selected,
              $placeHolder = $(this.model.inputElement),
              selectedDateText = _this.formatDate(unix);
            $placeHolder.html(selectedDate.year+"/"+selectedDate.month+"/"+selectedDate.date);
            $placeHolder.addClass('travel-search-types__form__dp--has-value');

            if($placeHolder.data("type")==="from"){
              _this.model.set({departDate:selectedDateText});
              _this.validateForm();

              _this.fromDP.touched = true;
              if (_this.toDP && _this.toDP.options && _this.toDP.options.minDate != unix) {
                var cachedValue = _this.toDP.getState().selected.unixDate;
                _this.toDP.options = {minDate: unix};
                if (_this.toDP.touched) {
                  _this.toDP.setDate(cachedValue);
                }
              }

            }else{
              _this.model.set({returnDate:selectedDateText});
              _this.validateForm();

              _this.toDP.touched = true;
              if(_this.fromDP && _this.fromDP.options && _this.fromDP.options.maxDate != unix){
                var cachedValue = _this.fromDP.getState().selected.unixDate;
                _this.fromDP.options = {maxDate: unix};
                if (_this.fromDP.touched) {
                  _this.fromDP.setDate(cachedValue);
                }
              }
            }
          },
          checkDate: function(unix){
            var $placeHolder = $(this.model.inputElement),
              currentDate = _this.formatDate(unix),
              currentTable = $placeHolder.data("type")==="from"?departureDates:returnDates;
            return !!currentTable && _.indexOf(currentTable, currentDate)!==-1;
          },
          minDate: new Date(),
          maxDate: null,
          autoClose: true,
          toolbox:{
            calendarSwitch:{
              enabled: false
            }
          }
        };

      var $datePickers = $(".tkh-travel-train-date-picker");
      $datePickers.each(function(){
        $(this).removeClass('travel-search-types__form__dp--has-value');
        $(this).removeClass('travel-search-types__form__dp--disabled');
        $(this).html($(this).data("ph"));
      });

      if(this.fromDP){
        this.fromDP.options = dpOptions;
      }
      if(this.toDP){
        this.toDP.options = dpOptions;
      }
      if(!this.toDP || !this.fromDP){
        $datePickers.each(function(){
          var dp = $(this).pDatepicker(dpOptions);
          if($(this).data("type")==="from"){
            _this.fromDP = dp;
          }else{
            _this.toDP = dp;
          }
        });
      }

      takhfifan.eventHub.trigger('travel:enable');
    },

    initFiltersAndDealCardsEvents: function () {
      var _this = this;

      _this.setPassengersCount();

      $(document).on('click', '.tkh-travel-train-card__more', function (e) {
        var $target = $(e.target);
        $target.parents('.tkh-travel-train-card').toggleClass('travel-train-result--with-details');
      });

      $(document).on('click', '.tkh-travel-train-sort', function (e) {
        var $target = $(e.target);
        $target.parents('.tkh-travel-train-results__sorts').find('.tkh-travel-train-sort').removeClass('active');
        $target.addClass('active');
        _this.currentPage = 0;
        _this.sort = $target.data('type');
        _this.renderCards(false, _this.travelType);
      });

      $(document).on('click', '.tkh-travel-train-results__show-more', function (e) {
        _this.currentPage++;
        $(this).remove();
        _this.renderCards(true, _this.travelType);
      });

      $(document).on('click','.tkh-travel-train-card__btn', function (e) {
        e.preventDefault();
        var ticketModelId = $(e.target).parents('.tkh-travel-train-card').data('model');
        _this.addToCart(ticketModelId);
      });

      $(document).on('click','.tkh-travel-raja-train-card__btn', function (e) {
        e.preventDefault();
        var ticketModelId = $(e.target).parents('.tkh-raja-train-cart').data('model');
        _this.rajaAddToCart(ticketModelId);
      });

      $(document).on('click','.tkh-checkbox-charter-coupe', function (e) {
        var $target = $(e.target),
            type = $target.data('type'),
            isChecked = $target.prop('checked');

        if(isChecked) {
          _this.model.set({charter_coupe: 1});
        }else{
          _this.model.set({charter_coupe: 0});
        }
        _this.renderCards(false, _this.travelType);
      });

      $(document).on('click', '.tkh-travel-block-collapsible', function (e) {
        $(this).toggleClass('travel-train-block--open');
      });

      $(document).on('click', '.tkh-passenger-increase-btn', function (e) {
        var $target = $(e.target),
            type = $target.data('type');

        if(type === 'adult'){
          var adultCount = _this.model.get('adult');
          try {
            _this.model.set({adult: adultCount+1});
            $('.tkh-adult-count-value').text(adultCount+1);
          }catch (e) {
            console.error(e);
          }
        }
        else if (type === 'child'){
          var childCount = _this.model.get('child');
          try {
            _this.model.set({child: childCount+1});
            $('.tkh-child-count-value').text(childCount + 1);
          }catch (e) {
            console.error(e);
          }
        }

        _this.setPassengersCount();
      });

      $(document).on('click', '.tkh-passenger-decrease-btn', function (e) {
        var $target = $(e.target),
            type = $target.data('type');

        if(type === 'adult'){
          var adultCount = _this.model.get('adult');
          if(adultCount > 1) {
            try {
              _this.model.set({adult: adultCount-1});
              $('.tkh-adult-count-value').text(adultCount - 1);
            }catch (e) {
              console.error(e);
            }
          }
        }
        else if (type === 'child'){
          var childCount = _this.model.get('child');
          if(childCount > 0) {
            try {
              _this.model.set({child: childCount-1});
              $('.tkh-child-count-value').text(childCount - 1);
            }catch (e) {
              console.error(e);
            }
          }
        }

        _this.setPassengersCount();
      });

      $(document).on('click', '.tkh-passenger-type-btn', function (e) {
        var $target = $(e.target),
            type = $target.data('type');

        $('.tkh-passenger-type-btn').removeClass('active');
        $target.addClass("active");

        $('.tkh-coupe-type').val("مسافرین " + $target.text());
        $('.coupe-entry').hide();

        _this.model.set({ticket_type: type})
      });

      $(document).on('click', '.tkh-train-checkout__action-pay', function (e) {
        _this.saveOrder();
      });

      $(document).on('click', '.tkh-payment-item', function (e) {
        var $target = $(e.currentTarget);
        $target.parent('.tkh-train-checkout__payments').find('.active').removeClass('active');
        $target.addClass('active');
        _this.savePaymentMethod($target.data("method"))
      });

      $(document).on('click', '.tkh-train-sort', function (e) {
        var $target = $(e.target),
          type = $target.data('type');
        _this.sort = type;
        _this.renderCards(false, _this.travelType);
      });

      $(document).on('click', '.tkh-train-another-day', function (e) {
        var $target = $(e.target),
          type = $target.data('type');

        var date = new Date(_this.model.get('departDate'));

        if(type === 'prev'){
          date.setDate(date.getDate() - 1);
        }else if(type === 'next'){
          date.setDate(date.getDate() + 1);
        }

        var dt = _this.formatDate(date);
        var dtJalali = new persianDate(date).format("YYYY-MM-DD");

        _this.model.set({departDate: dt});
        $(".tkh-travel-train-date-picker[data-type='from']").html(dtJalali.replace(/\-/g, '/'));

        _this.searchTrains();
      });

      $(document).on('click', '.tkh-terms-agreement', function (e) {
        var $target = $(e.target),
            isSelected = $target.is(':checked');

        if(isSelected){
          $('.tkh-reserve-train-ticket').removeAttr('disabled');
        }
        else {
          $('.tkh-reserve-train-ticket').prop('disabled', 'disabled');
        }
      });

      $(document).on('click', '.tkh-btn-change-ticket', function (e) {
        // TODO: check type when is2Way
        var $target = $(e.target),
            type = $target.data('type');

        if(type === "return"){
          var goingTicket = _.first(_this.tickets);
          _this.tickets = [];
          _this.tickets.push(goingTicket);
          _this.travelType = "return";
        }

        if(type === "going"){
          _this.travelType = "going";
          _this.tickets = [];
        }

        _this.optionalServicesPrices = [];

        _this.renderSearchResults();
        $('.tkh-travel-train-checkout__container').hide();
        $('.tkh-travel-page-view.tkh-travel-search-types[data-view=search]').show();
      });

      $(document).on('change', '.tkh-select-optional-services', function (e) {
        var $target = $(e.target),
            price = $target.find(':selected').data('price'),
            item = _.findWhere(_this.optionalServicesPrices, {passenger: $target.data('passenger')}),
            idx = _.indexOf(_this.optionalServicesPrices, item);

        if(idx !== -1){
          _this.optionalServicesPrices[idx]['price'] = price;
        }else{
          _this.optionalServicesPrices.push({
            price: $target.find(':selected').data('price'),
            passenger: $target.data('passenger')
          });
        }

        _this.calcOptionalServicesPrice();

      });
    },

    initOptionalServicesPrice: function(){
      var passengers = parseInt(this.model.get('adult')) + parseInt(this.model.get('child'));
      for (var i = 1; i < passengers+1; i++) {
        var el = $('.tkh-select-optional-services[data-passenger='+i+'][name=optional_services]');
        var price = el.find(':selected').data('price');
        if(price) {
          this.optionalServicesPrices.push({
            price: el.find(':selected').data('price'),
            passenger: i
          });
        }
      }
      this.calcOptionalServicesPrice();
    },

    calcOptionalServicesPrice: function(){
      var optionalServicesArr = [],
      optionalEls = $('.tkh-select-optional-services[name=optional_services]');
      optionalEls.each(function(){
        var value = parseInt($(this).find('option:selected').data('price'), 10);
        if(!_.isNaN(value)){
          optionalServicesArr.push(value);
        }
      });

      var sum = _.reduce(optionalServicesArr, function(memo, num){ return memo + num; }, 0);
      this.totalOptionalServicesPrice = sum;
      $('.tkh-optional-services-price').text(formatPrice(this.totalOptionalServicesPrice));
      $('.tkh-total-train-price').text(
        formatPrice(this.totalOptionalServicesPrice +
          (parseInt(this.passengersPricesObj.totalPrice.going,10) + parseInt(this.passengersPricesObj.totalPrice.return, 10))));
    },

    formatPrice: function(x){
      return parseInt(x/10,10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،") + " تومان";
    },

    setPassengersCount: function(){
      var adultPassengers = parseInt(this.model.get('adult'));
      var childPassengers = parseInt(this.model.get('child'));
      $('.tkh-input-passengers-count').val((adultPassengers + childPassengers) + " مسافر");
    },

    getPaymentMethods: function () {
      var _this = this;
      this.paymentMethodsPath = $('.train-order-register').data('paymentMethodsUrl');
      $.ajax({
        type: 'POST',
        url: _this.paymentMethodsPath,
        data: {form_key: takhfifan.formKey}
      }).done(function (data) {
        _this.initConfirmView(data);
      }).fail(function () {
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: 'عملیات با خطا مواجه شد.'
        });
      }).complete(function(){
        takhfifan.eventHub.trigger('travel:enable');
      });
    },

    initConfirmView:function (paymentMethods) {
      var template = _.template($("#train-payment-methods").html()),
        compiled_template = template({payment_methods:paymentMethods});
      $('.tkh-train-checkout-container').hide();
      $('.tkh-train-payments-container').show();
      $('.tkh-train-checkout__payments').html(compiled_template);
      var $firstMethod = $('.tkh-train-checkout__payments .tkh-payment-item').first();
      $firstMethod.addClass('active');
      this.savePaymentMethod($firstMethod.data("method"));
    },

    selectPaymentMethod: function(e) {
      var $target = $(e.currentTarget);
      $target.parent('.tkh-train-checkout__payments').find('.active').removeClass('active');
      $target.addClass('active');
      this.savePaymentMethod($target.data("method"))
    },

    savePaymentMethod: function (method) {
      var _this = this;
      this.savePaymentMethodsPath = $('.train-order-register').data('savePaymentMethodsUrl');
      this.$('.tkh-train-checkout__action-pay').prop('disabled','disabled');
      $.ajax({
        type: 'POST',
        url: this.savePaymentMethodsPath,
        data: {
          form_key: takhfifan.formKey,
          payment: {
            method: method
          }
        }
      }).done(function(data) {
        _this.paymentMethod = method;
        if(!data.error){
          _this.$('.tkh-travel-checkout__action-pay').removeAttr('disabled');
        }else{
          if(_this.isFirstPaymentCalled){
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: 'خطا در ثبت درگاه پرداخت، درگاه پرداخت را انتخاب کنید'
            });
          }
          else{
            _this.isFirstPaymentCalled = true;
            _this.savePaymentMethod(method);
          }
        }
      }).fail(function (data) {
        if(_this.isFirstPaymentCalled){
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'خطا در ثبت درگاه پرداخت، درگاه پرداخت را انتخاب کنید'
          });
        }
        else{
          _this.isFirstPaymentCalled = true;
          _this.savePaymentMethod(method);
        }
      });
    },

    saveOrder: function () {
      takhfifan.eventHub.trigger('travel:disable');
      var _this = this;
      $.ajax({
        type: 'POST',
        url: '/ajax/onepage/saveOrder/',
        data: {
          form_key: takhfifan.formKey,
          payment: {
            method: this.paymentMethod
          }
        }
      }).done(function (data) {
        if(data.redirect){
          Lockr.set('travelHotelData','');
          window.location.replace(data.redirect);
        }else{
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'عملیات با خطا مواجه شد.'
          });
        }
      }).fail(function () {
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: 'عملیات با خطا مواجه شد.'
        });
      }).complete(function(){
        takhfifan.eventHub.trigger('travel:enable');
      });
    },

    gatherPassengersData: function(){
      var passengers = parseInt(this.model.get('adult')) + parseInt(this.model.get('child')),
        passengersInfo = [];
      for (var i = 1; i < passengers+1; i++) {
        var birth = [
            parseInt($('.tkh-select-passenger-birthday[data-passenger='+i+'][name=birth_year]').val(),10),
            parseInt($('.tkh-select-passenger-birthday[data-passenger='+i+'][name=birth_month]').val(),10),
            parseInt($('.tkh-select-passenger-birthday[data-passenger='+i+'][name=birth_day]').val(),10)
          ],
          birthDay = new persianDate(birth);
        birthDay.toCalendar('gregorian');

        var age = this.getPassengerAge(birthDay),
            price_group = 1;

        if(age !== 'invalid' && age.years <= 12){
          price_group = 2;
        }


        var obj = {
          first_name: $('.tkh-input-passenger-first-name[data-passenger='+i+']').val(),
          last_name: $('.tkh-input-passenger-last-name[data-passenger='+i+']').val(),
          national_code: $('.tkh-input-passenger-national-code[data-passenger='+i+']').val(),
          price_group: price_group,
          service_type_code: {}
        };

        var optionalServiceGoing = parseInt($('.tkh-select-optional-services[data-passenger='+i+'][name=optional_services][data-path=going]').val(),10),
            optionalServiceReturn = parseInt($('.tkh-select-optional-services[data-passenger='+i+'][name=optional_services][data-path=return]').val(),10);

        if(!_.isNaN(optionalServiceGoing)){
          obj.service_type_code['outward'] = optionalServiceGoing;
        }
        if(!_.isNaN(optionalServiceReturn)){
          obj.service_type_code['return'] = optionalServiceReturn;
        }

        passengersInfo.push(obj);
      }
      return passengersInfo;
    },

    getPassengerAge: function(birthDay){
      var today = new Date();
      var birthday = new Date(birthDay);

      var differenceInMilisecond = today.valueOf() - birthday.valueOf();

      var year_age = Math.floor(differenceInMilisecond / 31536000000);
      var day_age = Math.floor((differenceInMilisecond % 31536000000) / 86400000);
      var month_age = Math.floor(day_age/30);
      day_age = day_age % 30;

      if (isNaN(year_age) || isNaN(month_age) || isNaN(day_age)) {
        return 'invalid';
      }
      else {
        return { years: year_age, months: month_age, days: day_age};
      }
    },

    renderCards: function(append, travelType){
      var _this = this;
      var departureDate = this.model.get('departDate'),
          returnDate = this.model.get('returnDate');

      var models = _.filter(this.collection.models, function(model){
        var adult = _this.model.get('adult'),
            child = _this.model.get('child'),
            capacity = model.get('capacity');
        var passengers = parseInt(adult) + parseInt(child);

        var outOfStock = false;
        if(model.get('returnData')){
          var _totalCapacity = model.get('departureCapacity') + model.get('returnCapacity');
          if(passengers > _totalCapacity){
            outOfStock = true;
          }
        }else{
          if(passengers > capacity){
            outOfStock = true;
          }
        }

        if(outOfStock){
          model.set({outOfStock: true});
        }
        else{
          var outOfStock = model.get('outOfStock');
          if(outOfStock) {
            model.set({outOfStock: false});
          }
        }

        var depDate = model.get('departureDate'),
            retDate = model.get('returnDate');
        if(returnDate){
          return (depDate == departureDate) && (retDate == returnDate);
        }
        return (depDate && depDate == departureDate);
      });

      if(!append){
        $('.tkh-travel-train-results__container').html('');
      }

      var searchParameters = this.getSearchParameters();
      var is2Way = _this.model.get('is2Way');
      if(this.isRajaEnabled) {
        for (var i = 0; i < this.collection.trainsModel.length; i++) {
          var item = this.collection.trainsModel[i];
          if(this.currentTravelType === 'going'){
            item['fromCity'] = this.model.get('origin_name');
            item['toCity'] = this.model.get('destination_name');
          }
          if(this.currentTravelType === 'return'){
            item['fromCity'] = this.model.get('destination_name');
            item['toCity'] = this.model.get('origin_name');
          }
          item['id'] = '_' + Math.random().toString(36).substr(2, 9);
          models.push(item);
        }

        var isCharter = _this.model.get('charter_coupe');

        if (isCharter === 1) {
          models = _.where(models, {is_compartment: "1"});
        }

        if (this.sort === 'date') {
          models = _.sortBy(models, function (model) {
            return model.exit_time;
          });
        }
        else if (this.sort === 'price') {
          models = _.sortBy(models, function (model) {
            return model.cost;
          });
        }

        models = _.where(models, {travel_type: travelType});

        $('.tkh-travel-train-results__container').append(
          _this.cardTemplate({models:models, modelsCount: models.length, isCharter: isCharter ,
            searched: searchParameters, isRajaEnabled: _this.isRajaEnabled, is2Way: is2Way})
        );

        if(travelType === 'return'){
          $('.col-md-6.col-lg-6.going').removeClass("active");
          $('.col-md-6.col-lg-6.return').addClass("active");
        }else{
          $('.col-md-6.col-lg-6.return').removeClass("active");
          $('.col-md-6.col-lg-6.going').addClass("active");
        }

      }else{
        if(this.sort){
          models = _.sortBy(models, function(model){
            return model.get(_this.sort);
          });
        }

        var numberOfPages = Math.ceil(models.length / this.pageSize) - 1;
        models = _.rest(models, (this.currentPage) * this.pageSize);
        models = _.first(models, this.pageSize);

        $('.tkh-travel-train-results__container').append(
          _this.cardTemplate({models:models, showMore: this.currentPage<numberOfPages, searched: searchParameters,
            isRajaEnabled: _this.isRajaEnabled, is2Way: is2Way})
        );
      }



    },

    getSearchParameters: function(){
      var is2Way = this.model.get('is2Way'),
          departDate = this.model.get('departDate'),
          returnDate = null,
          searched = null;
      if(is2Way){
        returnDate = this.model.get('returnDate');
        searched = {
          goingDate: {
            fa: this.getDateName(departDate, "fa-IR"),
            en: this.getDateName(departDate, "en-US"),
          },
          returnDate:{
            fa: this.getDateName(returnDate, "fa-IR"),
            en: this.getDateName(returnDate, "en-US"),
          }
        }
      }else{
        searched = {
          goingDate: {
            fa: this.getDateName(departDate, "fa-IR"),
            en: this.getDateName(departDate, "en-US"),
          }
        }
      }
      return searched;
    },

    getDateName: function(dateStr, locale) {
      var date = new Date(dateStr);
      return {
        day: date.toLocaleDateString(locale, { day: 'numeric' }),
        dayName: date.toLocaleDateString(locale, { weekday: 'long'}),
        month: date.toLocaleDateString(locale, { month: 'long' }),
      };
    },

    renderSearchResults: function () {
      takhfifan.eventHub.trigger('travel:enable');

      if(this.collection.trainsModel.length || this.collection.models.length){
        $('.travel-train-results').removeClass('travel-train-results--no-result');
        $('.landingSection').css('display', 'none');
        takhfifan.eventHub.trigger('travel:renderResults', {type:'train'});
      }else{
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: 'جستجوی شما نتیجه ای در بر نداشت!'
        });
      }
      this.currentPage = 0;
      this.renderCards(false, this.travelType);
    },

    magentoUrlEncode: function(s) {
      return btoa(s)
        .replace(/\+/g,'-')
        .replace(/\//g,'_')
        .replace(/=/g, ',');
    },

    generateAddToCartFrom: function(){
      this.$add2CartForm = $('<form />').prop({
        method: 'post',
        action: '#'
      }).css('display', 'none');

      this.$add2CartForm2 = $('<form />').prop({
        method: 'post',
        action: '#'
      }).css('display', 'none');

      this.$el.append(this.$add2CartForm);
      this.$el.append(this.$add2CartForm2);
    },

    addToCartUrl: function(isForAdult, departureItem, relatedProductId) {
      var urlPart = window.location.origin + '/ajax/product/elements/i/' +  departureItem.id;
      var action = null;

      if(isForAdult) {
        action = window.location.origin + '/checkout/cart/add' +
          '/uenc/' + this.magentoUrlEncode(urlPart) +
          '/product/' + departureItem.id +
          '/qty/' + this.model.get('adult') +
          '/form_key/' + takhfifan.formKey;
          if(relatedProductId){
            action += '/related_product/' + relatedProductId;
          }
      }
      else {
        var custom_options = null;
        if (departureItem.custom_options && departureItem.custom_options.length > 0) {
          custom_options = departureItem.custom_options[0];
        }
        action = window.location.origin + '/checkout/cart/add' +
          '/uenc/' + this.magentoUrlEncode(urlPart) +
          '/product/' + departureItem.id +
          '/qty/' + this.model.get('child') +
          '/form_key/' + takhfifan.formKey;
        if(relatedProductId){
          action += '/related_product/' + relatedProductId;
        }
        if (custom_options) {
          action +=
            '?options[' + custom_options.option_id + ']=' + custom_options.options[0].id
        }
      }

      return action;
    },

    generateCallAPIData: function(isForAdult, departureItem, returnItem){
      if(isForAdult) {
        this.callData.push({"product_id": departureItem.id, "qty": this.model.get('adult'), "replace": true});
        if(returnItem){
          this.callData.push({"product_id": returnItem.id, "qty": this.model.get('adult'), "replace": true});
        }
      }
      else{
        var custom_options = null,
            custom_optionsArr = [];

        if (departureItem.custom_options && departureItem.custom_options.length > 0) {
          custom_options = departureItem.custom_options[0];
        }
        if (custom_options) {
          custom_optionsArr.push({"id": custom_options.option_id,"value": custom_options.options[0].id});
          this.callData.push({"product_id": departureItem.id, "qty": this.model.get('child'), "custom_options":custom_optionsArr});
        }
        else{
          this.callData.push({"product_id": departureItem.id, "qty": this.model.get('child')});
        }
        if(returnItem){
          var return_custom_options = null,
            return_custom_optionsArr = [];

          if (returnItem.custom_options && returnItem.custom_options.length > 0) {
            return_custom_options = returnItem.custom_options[0];
          }
          if (return_custom_options) {
            return_custom_optionsArr.push({"id": return_custom_options.option_id,"value": return_custom_options.options[0].id});
            this.callData.push({"product_id": returnItem.id, "qty": this.model.get('child'), "custom_options":return_custom_optionsArr});
          }
          else{
            this.callData.push({"product_id": returnItem.id, "qty": this.model.get('child')});
          }
        }
      }
    },

    addToCart: function (modelId) {
        var model = this.collection.get(modelId),
            adultAddToCartUrl = "",
            childAddToCartUrl = "",
            departureItem = model.get("departure"),
            returnItem = model.get("returnData");

      var child = this.model.get('child');
      this.generateCallAPIData(true, departureItem, returnItem);
      if(child && child>0) {
        this.generateCallAPIData(false, departureItem, returnItem);
      }
      var apiUrl = window.location.origin + '/checkout/cart/addAll' + '/form_key/' + takhfifan.formKey;

      var body = JSON.stringify(this.callData);
      takhfifan.eventHub.trigger('travel:disable');

      var _this = this;
      var call = $.post(apiUrl, body);
      call.done(function (response) {
        if(response && response.success){
          window.location.replace("/checkout/cart/");
        }
        else{
          takhfifan.eventHub.trigger('travel:enable');
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'خطایی رخ داده است. لطفا مجددا تلاش بفرمایید!'
          });
        }
      });

    },

    renderReturnAvailableTrains: function(){
      this.travelType = "return";
      this.renderCards(false, 'return');
    },

    rajaAddToCart: function (id) {
      var item = _.where(this.collection.trainsModel, {id: id});
      if(this.model.get('is2Way') && this.tickets.length === 0) {
        this.tickets.push(item[0]);
        this.currentTravelType = "going";
        this.renderCards(false, 'return');
      }else if(this.model.get('is2Way') && this.tickets.length === 1) {
        this.tickets.push(item[0]);
        this.currentTravelType = "return";
        this.getPriceAndRenderCheckout();
      }else if(!this.model.get('is2Way') && this.tickets.length === 0) {
        this.tickets.push(item[0]);
        this.getPriceAndRenderCheckout();
      }
      else{
        this.getPriceAndRenderCheckout();
      }
    },

    showHideAge: function () {
      $('.passenger-entry').toggle();
    },

    showHideType: function () {
      $('.coupe-entry').toggle();
    },

    getPriceAndRenderCheckout: function () {
      takhfifan.eventHub.trigger('travel:disable');
      var _this = this,
          adultPassengers = parseInt(this.model.get('adult')),
          childPassengers = parseInt(this.model.get('child')),
          is2Way = this.model.get('is2Way'),
          passengers = {
            adult: {
              count: adultPassengers,
              price: {
                going: '0',
                return: '0'
              }
            },
            child: {
              count: childPassengers,
              price: {
                going: '0',
                return: '0'
              }
            },
            isCharter:_this.model.get('charter_coupe'),
            totalPrice: {
              going: '0',
              return: '0'
            },
            charterPrice: {
              going: '0',
              return: '0'
            }
          };

      for (var i= 0; i< this.tickets.length;i++){
        if(is2Way && this.tickets[i].travel_type === 'return') {
          this.tickets[i]['origin'] = parseInt(_this.model.get('destination'));
          this.tickets[i]['destination'] = parseInt(_this.model.get('origin'));
        } else if(is2Way && this.tickets[i].travel_type === 'going'){
          this.tickets[i]['origin'] = parseInt(_this.model.get('origin'));
          this.tickets[i]['destination'] = parseInt(_this.model.get('destination'));
        } else{
          this.tickets[i]['origin'] = parseInt(_this.model.get('origin'));
          this.tickets[i]['destination'] = parseInt(_this.model.get('destination'));
        }

        this.tickets[i]['charter'] = _this.model.get('charter_coupe');
        this.tickets[i]['adult'] = adultPassengers;
        this.tickets[i]['child'] = childPassengers;
      }

      if(is2Way){
        this.collection.fetchCoupePrice({
          dataType: 'json',
          data: {
            form_key: takhfifan.formKey,
            ticket: _this.tickets[0],
          },
          success: function (collection) {
            passengers.adult.price.going = parseInt(collection.coupePriceModel.adult_price);
            passengers.child.price.going = parseInt(collection.coupePriceModel.child_price);
            passengers.totalPrice.going = parseInt(collection.coupePriceModel.total_price);
            passengers.charterPrice.going = parseInt(collection.coupePriceModel.charter_price);

            _this.collection.fetchCoupePrice({
              dataType: 'json',
              data: {
                form_key: takhfifan.formKey,
                ticket: _this.tickets[1],
              },
              success: function (collection) {
                passengers.adult.price.return = parseInt(collection.coupePriceModel.adult_price);
                passengers.child.price.return = parseInt(collection.coupePriceModel.child_price);
                passengers.totalPrice.return = parseInt(collection.coupePriceModel.total_price);
                passengers.charterPrice.return = parseInt(collection.coupePriceModel.charter_price);

                _this.passengersPricesObj = passengers;
                _this.getOptionalServices(passengers);

              },
              error: function () {},
              complete: function () {}
            });

          },
          error: function () {},
          complete: function () {}
        });
      }
      else {
        this.collection.fetchCoupePrice({
          dataType: 'json',
          data: {
            form_key: takhfifan.formKey,
            ticket: _this.tickets[0],
          },
          success: function (collection) {
            passengers.adult.price.going = parseInt(collection.coupePriceModel.adult_price);
            passengers.child.price.going = parseInt(collection.coupePriceModel.child_price);
            passengers.totalPrice.going = parseInt(collection.coupePriceModel.total_price);
            passengers.charterPrice.going = parseInt(collection.coupePriceModel.charter_price);

            _this.passengersPricesObj = passengers;
            _this.getOptionalServices(passengers);
          },
          error: function () {},
          complete: function () {}
        });
      }
    },

    getOptionalServices: function(passengers){
      var _this = this,
          is2Way = this.model.get('is2Way');
          optionalData = {
            going: [],
            return: []
          };

      if(is2Way) {
        this.collection.fetchOptionalServices({
          dataType: 'json',
          data: {
            form_key: takhfifan.formKey,
            ticket: _this.tickets[0],
          },
          success: function (collection) {
            if(!collection.optionalServices.error) {
              optionalData.going = collection.optionalServices;
            }
            _this.collection.fetchOptionalServices({
              dataType: 'json',
              data: {
                form_key: takhfifan.formKey,
                ticket: _this.tickets[1],
              },
              success: function (collection) {
                if(!collection.optionalServices.error) {
                  optionalData.return = collection.optionalServices;
                }
                _this.renderRajaCheckoutSection(passengers, optionalData);
              },
              error: function () {},
              complete: function () {
              }
            });
          },
          error: function () {},
          complete: function () {
          }
        });

      }
      else{
        this.collection.fetchOptionalServices({
          dataType: 'json',
          data: {
            form_key: takhfifan.formKey,
            ticket: _this.tickets[0],
          },
          success: function (collection) {
            if(!collection.optionalServices.error) {
              optionalData.going = collection.optionalServices;
            }
            _this.renderRajaCheckoutSection(passengers, optionalData);
          },
          error: function () {},
          complete: function () {
          }
        });
      }
    },

    renderRajaCheckoutSection: function (passengers, optionalServices) {
      var _this = this;
      var searchParameters = this.getSearchParameters();

      $('.tkh-travel-train-checkout__container').html('').append(
        this.trainCartTemplate({tickets: this.tickets, passengers: passengers, optionalServices: optionalServices,
          searched: searchParameters, is2Way: this.model.get('is2Way')})
      ).show('');
      window.scrollTo(0, 0);
      takhfifan.eventHub.trigger('travel:enable');
      $(".tkh-travel-page-view.tkh-travel-search-types[data-view=search]").hide();
      // $('.tkh-travel-train-checkout__container').;

      this.initOptionalServicesPrice();
      this.calcOptionalServicesPrice();
      $('#passengersInfoForm').parsley().on('form:validated', function() {
        var formIsValid = $('.parsley-error').length === 0;

        if(formIsValid) {
          var passengersInfo = _this.gatherPassengersData();
          var _ticketObj = {
            "formKey": takhfifan.formKey,
            "origin": parseInt(_this.model.get('origin')),
            "origin_name": _this.model.get('origin_name'),
            "destination": parseInt(_this.model.get('destination')),
            "destination_name": _this.model.get('destination_name'),
            "seats": passengersInfo.length,
            "ticket_type": _this.model.get('ticket_type'),
            "charter_coupe": _this.model.get('charter_coupe'),
            "email": $('.tkh-input-passenger-email').val(),
            "phone_number": $('.tkh-input-passenger-mobile').val(),
            "passengers": passengersInfo,
            "outward":{
              "route": "outward",
              "departing_time": _this.tickets[0].exit_datetime,
              "train_number": parseInt(_this.tickets[0].train_number),
              "wagon_type": parseInt(_this.tickets[0].wagon_type),
              "degree": parseInt(_this.tickets[0].degree),
              "sold_count": parseInt(_this.tickets[0].sold_count),
              "circular_number_serial": parseInt(_this.tickets[0].circular_number_serial),
              "rate_code": parseInt(_this.tickets[0].rate_code),
              "path_code": parseInt(_this.tickets[0].path_code),
              "compartment_capacity": parseInt(_this.tickets[0].compartment_capicity),
              "ration_code": parseInt(_this.tickets[0].ration_code),
              "circular_period": parseInt(_this.tickets[0].circular_period),
            }
          };
          if(_this.model.get('is2Way')){
            _ticketObj["return"] = {
              "route": "return",
              "departing_time": _this.tickets[1].exit_date,
              "train_number": parseInt(_this.tickets[1].train_number),
              "wagon_type": parseInt(_this.tickets[1].wagon_type),
              "degree": parseInt(_this.tickets[1].degree),
              "sold_count": parseInt(_this.tickets[1].sold_count),
              "circular_number_serial": parseInt(_this.tickets[1].circular_number_serial),
              "rate_code": parseInt(_this.tickets[1].rate_code),
              "path_code": parseInt(_this.tickets[1].path_code),
              "compartment_capacity": parseInt(_this.tickets[1].compartment_capicity),
              "ration_code": parseInt(_this.tickets[1].ration_code),
              "circular_period": parseInt(_this.tickets[1].circular_period),
            };
          }

          this.saveOrderPath = $('.train-order-register').data('saveOrderUrl');
          takhfifan.eventHub.trigger('travel:disable');

          $.ajax({
            type: 'POST',
            url: this.saveOrderPath,
            data: _ticketObj
          }).done(function (data) {
            if (data.quote_id) {
              _this.getPaymentMethods();
            } else {
              takhfifan.eventHub.trigger('message:show', {
                type: 'error',
                msg: 'عملیات با خطا مواجه شد.'
              });
              takhfifan.eventHub.trigger('travel:enable');
            }
          }).fail(function (e) {
            console.log("train reserve error: ", e);
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: 'عملیات با خطا مواجه شد.'
            });
            takhfifan.eventHub.trigger('travel:enable');
          }).complete(function () {
          });
        }
        else{
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'لطفا اطلاعات درخواستی را وارد کنید.'
          });
          takhfifan.eventHub.trigger('travel:enable');
        }
      }).on('form:submit', function() {
        return false;
      });
    },

  });


});

